var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5254 9.77734C34.2216 9.12475 35.236 8.95793 36.0977 9.33887L36.2676 9.42285C37.6424 10.167 37.9196 12.0036 36.8652 13.1211L36.7598 13.2275L27.71 21.7119C26.8084 22.557 25.4368 22.6095 24.4766 21.8701L24.29 21.7119L15.2402 13.2275C14.0998 12.1583 14.2988 10.3108 15.6025 9.49805L15.7324 9.42285C16.5718 8.96859 17.5955 9.06553 18.332 9.65332L18.4746 9.77734L23.6064 14.5879C24.9108 15.8107 26.9175 15.8487 28.2656 14.7021L28.3936 14.5879L33.5254 9.77734Z",
    fill: "url(#paint0_linear_905_9859)",
    stroke: "url(#paint1_linear_905_9859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5254 42.2227C34.2216 42.8752 35.236 43.0421 36.0977 42.6611L36.2676 42.5771C37.6424 41.833 37.9196 39.9964 36.8652 38.8789L36.7598 38.7725L27.71 30.2881C26.8084 29.443 25.4368 29.3905 24.4766 30.1299L24.29 30.2881L15.2402 38.7725C14.0998 39.8417 14.2988 41.6892 15.6025 42.502L15.7324 42.5771C16.5718 43.0314 17.5955 42.9345 18.332 42.3467L18.4746 42.2227L23.6064 37.4121C24.9108 36.1893 26.9175 36.1513 28.2656 37.2979L28.3936 37.4121L33.5254 42.2227Z",
    fill: "url(#paint2_linear_905_9859)",
    stroke: "url(#paint3_linear_905_9859)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77734 33.5254C9.12475 34.2216 8.95793 35.236 9.33887 36.0977L9.42285 36.2676C10.167 37.6424 12.0036 37.9196 13.1211 36.8652L13.2275 36.7598L21.7119 27.71C22.557 26.8084 22.6095 25.4368 21.8701 24.4766L21.7119 24.29L13.2275 15.2402C12.1583 14.0998 10.3108 14.2988 9.49805 15.6025L9.42285 15.7324C8.96859 16.5718 9.06553 17.5955 9.65332 18.332L9.77734 18.4746L14.5879 23.6064C15.8107 24.9108 15.8487 26.9175 14.7021 28.2656L14.5879 28.3936L9.77734 33.5254Z",
    fill: "url(#paint4_linear_905_9859)",
    stroke: "url(#paint5_linear_905_9859)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2227 33.5254C42.8752 34.2216 43.0421 35.236 42.6611 36.0977L42.5771 36.2676C41.833 37.6424 39.9964 37.9196 38.8789 36.8652L38.7725 36.7598L30.2881 27.71C29.443 26.8084 29.3905 25.4368 30.1299 24.4766L30.2881 24.29L38.7725 15.2402C39.8417 14.0998 41.6892 14.2988 42.502 15.6025L42.5771 15.7324C43.0314 16.5718 42.9345 17.5955 42.3467 18.332L42.2227 18.4746L37.4121 23.6064C36.1893 24.9108 36.1513 26.9175 37.2979 28.2656L37.4121 28.3936L42.2227 33.5254Z",
    fill: "url(#paint6_linear_905_9859)",
    stroke: "url(#paint7_linear_905_9859)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 5,
    r: 4.5,
    fill: "url(#paint8_linear_905_9859)",
    stroke: "url(#paint9_linear_905_9859)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 21 52)",
    fill: "url(#paint10_linear_905_9859)",
    stroke: "url(#paint11_linear_905_9859)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(0 1 1 0 0 21)",
    fill: "url(#paint12_linear_905_9859)",
    stroke: "url(#paint13_linear_905_9859)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 26,
    r: 4.5,
    transform: "rotate(90 47 26)",
    fill: "url(#paint14_linear_905_9859)",
    stroke: "url(#paint15_linear_905_9859)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_905_9859",
    x1: 39.087,
    y1: 22.7826,
    x2: 28.5987,
    y2: 4.42809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BDDFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_905_9859",
    x1: 26,
    y1: 13.5,
    x2: 26,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4883",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_905_9859",
    x1: 39.087,
    y1: 29.2174,
    x2: 28.5987,
    y2: 47.5719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D072E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_905_9859",
    x1: 26,
    y1: 38.5,
    x2: 26,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A258B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A258B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_905_9859",
    x1: 22.7826,
    y1: 39.087,
    x2: 4.42809,
    y2: 28.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_905_9859",
    x1: 13.5,
    y1: 26,
    x2: 24,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC5D23",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5D23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_905_9859",
    x1: 29.2174,
    y1: 39.087,
    x2: 47.5719,
    y2: 28.5987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44D8C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_905_9859",
    x1: 38.5,
    y1: 26,
    x2: 28,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_905_9859",
    x1: 30.6739,
    y1: 9.23913,
    x2: 23.0652,
    y2: 1.63044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BDDFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_905_9859",
    x1: 26,
    y1: 3.4375,
    x2: 26,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4883",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_905_9859",
    x1: 9.67391,
    y1: 9.23913,
    x2: 2.06522,
    y2: 1.63044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D072E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_905_9859",
    x1: 5,
    y1: 3.4375,
    x2: 5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A258B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A258B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_905_9859",
    x1: 9.67391,
    y1: 9.23913,
    x2: 2.06522,
    y2: 1.63044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_905_9859",
    x1: 5,
    y1: 3.4375,
    x2: 5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC5D23",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5D23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_905_9859",
    x1: 51.6739,
    y1: 30.2391,
    x2: 44.0652,
    y2: 22.6304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44D8C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_905_9859",
    x1: 47,
    y1: 24.4375,
    x2: 47,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196C67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtsLogo);
export default __webpack_public_path__ + "static/media/ats-logo.d4ba9b32ac1dd011c93b99e148a6b870.svg";
export { ForwardRef as ReactComponent };